/**
 * Pure math for comparing job offers.
 * Assigns a monetary value to benefits/PTO to calculate total adjusted compensation.
 */
export function compareOffers(offer1, offer2) {
    const calculateValue = (o) => {
        const annualSalary = o.salary || 0;
        const annualBonus = o.bonus || 0;
        const dailyRate = annualSalary / 260; // 52 weeks * 5 days
        
        // Value PTO based on daily rate
        const ptoValue = (o.ptoDays || 0) * dailyRate;
        // Value retirement match as actual cash match
        const retirementValue = annualSalary * ((o.retirementMatch || 0) / 100);
        
        // Commute cost is subtracted (assume 48 working weeks * 5 days * daily cost)
        const annualCommuteCost = (o.commuteMiles || 0) * 2 * 5 * 48 * (o.commuteCostPerMile || 0.65); // IRS standard ~0.65
        
        const totalAdjustedComp = annualSalary + annualBonus + ptoValue + retirementValue - annualCommuteCost;
        
        return { ...o, dailyRate, ptoValue, retirementValue, annualCommuteCost, totalAdjustedComp };
    };

    const c1 = calculateValue(offer1);
    const c2 = calculateValue(offer2);

    return {
        offer1: c1,
        offer2: c2,
        difference: c1.totalAdjustedComp - c2.totalAdjustedComp,
        betterOffer: c1.totalAdjustedComp > c2.totalAdjustedComp ? 1 : 2
    };
}
